import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GlobalSettings } from './environments/global-settings';

environment.globalSettings = new GlobalSettings();

if (environment.production) {
  enableProdMode();
}

const favIcon = document.createElement('link');
favIcon.href = environment.faviconUrl ? environment.faviconUrl : '/store/theme/favicon.ico';
favIcon.type = 'image/x-icon';
favIcon.rel = 'icon';
document.head.appendChild(favIcon);

const styleLocation = document.createElement('link');
styleLocation.href = environment.linkLocationCSS ? environment.linkLocationCSS : 'static/css/main_styles.css';
styleLocation.type = 'text/css';
styleLocation.rel = 'stylesheet';

document.title = environment.title || 'Web Shop';

document.head.appendChild(styleLocation);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
